let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ePkyJ")).then(() => parcelRequire('69j0k'));